import { styled } from 'parkdepot-shared/theme'

export const Container = styled('section', ({ $theme }) => ({
    display: 'flex',
    gap: '1rem',
    margin: '1.2rem 0'
}))

export const Title = styled('h2', ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    color: '#000',
    fontWeight: 600,
    margin: 0
}))

export const PriceTextContainer = styled('div', ({}) => ({
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column'
}))

export const PriceTextWrapper = styled('dl', () => ({
    margin: '0 0 0 2.4rem'
}))

export const PriceName = styled('dt', ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    color: '#000',
    fontWeight: 400,
    margin: 0,
    width: '15rem',
    lineHeight: '2.4rem'
}))

export const PriceValue = styled('dd', ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    color: '#000',
    fontWeight: 400,
    margin: 0,
    lineHeight: '2.4rem'
}))
